import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UserAuthenticationService } from '../../services/user-authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent implements OnInit {
  isUserAuthenticated = false;

  constructor(
    private messageService: MessageService,
    private userAuthenticationService: UserAuthenticationService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: this.translateService.instant('Unauthorized_Mesagge'),
      key: 'unauthorized',
      life: 3000,
    });

    this.isUserAuthenticated = this.userAuthenticationService.isUserAuthenticated;
  }
}
